import './PaymentInfoCard.scss'

import { Button } from 'antd'
import {Maybe} from "graphql/jsutils/Maybe";
import React from 'react'

import {Sepet, SepetSatiri} from '../../gql/GeneratedGraphqlTypes'

interface Props {
  data: Sepet
  onPurchase: () => void
  showIndirimsizFiyat?: boolean
}

const PaymentInfoCard = ({ data, onPurchase, showIndirimsizFiyat = true }: Props) => {
  const isMobile = window.innerWidth <= 768
  if (!data) return null;

  // Toplam Adet
  const toplamAdet = data.urunler?.reduce((acc: number, u: Maybe<SepetSatiri>) => {
    if (!u) return acc;
    return acc + u.adet;
  }, 0) || 0;

  // İndirimsiz Sepet Tutarı (KDV Dahil)
  const indirimsizSepetTutari = data.urunler?.reduce((acc: number, u: Maybe<SepetSatiri>) => {
    if (!u) return acc;
    return acc + parseFloat(u.indirimsiz_birim_fiyat) * u.adet;
  }, 0) || 0;
  const indirimsizKdvsizSepetTutari = data.urunler?.reduce((acc: number, u: Maybe<SepetSatiri>) => {
    if (!u) return acc;
    const fiyat = parseFloat(u.indirimsiz_birim_fiyat);
    const kdvYuzde = u.urun?.kdv_yuzde || 0;
    const kdvHaric = fiyat / (1 + kdvYuzde / 100);
    return acc + kdvHaric * u.adet;
  }, 0) || 0;

  // İndirimli Sepet Tutarı (KDV Dahil)
  const indirimliKdvsizSepetTutari = data.urunler?.reduce((acc: number, u: Maybe<SepetSatiri>) => {
    if (!u) return acc;
    return acc + parseFloat(u.indirimli_birim_fiyat) * u.adet;
  }, 0) || 0;

  const indirimliSepetTutari = data.urunler?.reduce((acc: number, u: Maybe<SepetSatiri>) => {
    if (!u) return acc;
    const fiyat = parseFloat(u.indirimli_birim_fiyat);
    const kdvYuzde = u.urun?.kdv_yuzde || 0;
    const kdvHaric = fiyat / (1 + kdvYuzde / 100);
    return acc + kdvHaric * u.adet;
  }, 0) || 0;
  // İndirim Tutarı (KDV Dahil)
  const indirimTutari = indirimsizKdvsizSepetTutari - indirimliSepetTutari;

  // Ödenecek Tutar (KDV Hariç)
  const kdvHariçSepetTutari = data.urunler?.reduce((acc: number, u: Maybe<SepetSatiri>) => {
    if (!u) return acc;
    const fiyat = parseFloat(u.indirimli_birim_fiyat);
    const kdvYuzde = u.urun?.kdv_yuzde || 0;
    const kdvHariç = fiyat / (1 + kdvYuzde / 100);
    return acc + kdvHariç * u.adet;
  }, 0) || 0;

  // KDV Tutarı
  const kdvTutari = indirimliKdvsizSepetTutari - kdvHariçSepetTutari;
  const ozet = kdvHariçSepetTutari + kdvTutari
  // Formatlı değerler
  const formatTL = (deger: number) =>
      deger.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });


  return (
    <>
      {isMobile ? (
        <div className="payment-info-card-mobile">
          <div className='total'>
            <span className='title'>Ödenecek tutar </span>
            {data.ogretmen_indirimi_uygulandi && (
              <span className="personel-indirim-badge">
                Üye indiriminiz uygulandı: -{formatTL(parseFloat(data.ogretmen_indirimi_tutari || '0'))} ₺
              </span>
            )}
            <span className='price'>
             {formatTL(ozet)} ₺
            </span>
          </div>
          <div>
            <Button type={'primary'} className="sepeti-onayla-button" block onClick={onPurchase}>
              Ödemeye Geç
            </Button>
          </div>
        </div>
      ) : (
        <div className="payment-info-card">
          <div className="header">
            <h4>Sepet Özeti</h4>
            <span>{data.urunler?.length} Çeşit Ürün </span>
          </div>

          <div className="total-info">
            {showIndirimsizFiyat && (
              <p className="info-text-container">
                <span className="info-text-head">İndirimsiz Sepet Tutarı (KDV Hariç):</span>
                <span className="info-text-value">{formatTL(indirimsizSepetTutari)} ₺</span>
              </p>
            )}
            {showIndirimsizFiyat && (
              <p className="info-text-container">
                <span className="info-text-head">İndirim Tutarı (KDV Hariç):</span>
                <span className="info-text-value">{formatTL(indirimTutari)} ₺</span>
              </p>
            )}
            {data.ogretmen_indirimi_uygulandi && (
              <p className="info-text-container">
                <span className="info-text-head">Üye İndiriminiz:</span>
                <span className="info-text-value bedavas-color">
                  -{formatTL(parseFloat(data.ogretmen_indirimi_tutari || '0'))} ₺
                </span>
              </p>
            )}
            <p className="info-text-container">
              <span className="info-text-head">Toplam Adet:</span>
              <span className="info-text-value">{toplamAdet}</span>
            </p>
            <p className="info-text-container">
              <span className="info-text-head">Ödenecek Tutar (KDV Hariç):</span>
              <span className="info-text-value">{formatTL(kdvHariçSepetTutari)} ₺</span>
            </p>
            <p className="info-text-container">
              <span className="info-text-head">KDV Tutarı:</span>
              <span className="info-text-value">{formatTL(kdvTutari)} ₺</span>
            </p>

          </div>
          <hr style={{ margin: '8px 0', borderColor: '#f0f0f0' }} />
          <div>
            <span className="price"> {formatTL(ozet)} ₺</span>
          </div>
          <div>
            <Button type={'primary'} className="sepeti-onayla-button" block onClick={onPurchase}>
              Ödemeye Geç
            </Button>
          </div>
        </div>
      )}
    </>
  )
}

export default PaymentInfoCard
